<template>
  <v-textarea
    ref="input"
    :value="value || ''"
    class="summary--textarea"
    :error-messages="errorMessages"
    dense
    rows="1"
    auto-grow
    hide-details
    @input="(v) => $emit('input', v)"
    v-on="$listeners"
  >
  </v-textarea>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    invalid: { type: Boolean, default: true },
    errorMessages: { type: Array, default: () => [] },
  },
}
</script>

<style scoped lang="scss">
.summary--textarea {
  margin-top: 0 !important;

  .v-input__control textarea {
    line-height: 20px !important;
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
}
</style>
